"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ANALYTICS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.ANALYTICS;
  }
});
Object.defineProperty(exports, "BRAND_OVERLAY", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.BRAND_OVERLAY;
  }
});
Object.defineProperty(exports, "BULK_UPLOADING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.BULK_UPLOADING;
  }
});
Object.defineProperty(exports, "CLOSED_CAPTIONS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.CLOSED_CAPTIONS;
  }
});
Object.defineProperty(exports, "MOBILE_SCREEN_SUPPORT", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.MOBILE_SCREEN_SUPPORT;
  }
});
Object.defineProperty(exports, "PRIVACY_OPTIONS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.PRIVACY_OPTIONS;
  }
});
Object.defineProperty(exports, "SOCIAL_SHARING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.SOCIAL_SHARING;
  }
});
Object.defineProperty(exports, "STORAGE_VIEWING_CAPABILITIES", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.STORAGE_VIEWING_CAPABILITIES;
  }
});
Object.defineProperty(exports, "VIDEO_HOSTING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.VIDEO_HOSTING;
  }
});
Object.defineProperty(exports, "VIDEO_LOOPING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.VIDEO_LOOPING;
  }
});
Object.defineProperty(exports, "VIDEO_STREAMING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.VIDEO_STREAMING;
  }
});

var _CategoryFeature = require("../CategoryFeature");


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/constants/groupTags/categoryFeatures/Video.js
// module id = 585
// module chunks = 209 210 211 212 213